module.exports = __webpack_public_path__ + "img/digital-marketing.b81bea49.jpg";